import React, { useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import { ScrollToTop, ProtectedRoute } from './components'
import { authService } from './services/authService'
import {
  HomeScreen,
  LoginScreen,
  PasswordResetScreen,
  TurbineManagementScreen,
  UserManagementScreen,
  CompanyManagementScreen,
  Turbine360ViewScreen,
  OperatorPhotosScreen,
  DronePhotosScreen,
  RobotPhotosScreen,
  RobotScreen,
  AboutScreen,
  ContactScreen,
  PrivacyScreen,
  BlogDetailScreen
} from './screens'
import TurbineDetailScreen from './screens/TurbineDetail'
import MobileBlocker from './components/MobileBlocker'
import { LanguageProvider } from './contexts/LanguageContext'
import { NotificationProvider } from './contexts/NotificationContext'
import ErrorBoundary, { GlobalErrorListener } from './components/ErrorBoundary'

const App: React.FC = () => {
  // Clear cache on app startup to prevent stale user role data
  useEffect(() => {
    authService.clearAllCache();
  }, []);

  return (
    <LanguageProvider>
      <NotificationProvider>
      <GlobalErrorListener />
      <ErrorBoundary>
      <Router>
        <ScrollToTop />
        <Routes>
        {/* Login Route - Outside Layout */}
        <Route path="/login" element={
          <MobileBlocker allowMobile={false}>
            <LoginScreen />
          </MobileBlocker>
        } />
        
        {/* Password Reset Route - Outside Layout */}
        <Route path="/password-reset" element={
          <MobileBlocker allowMobile={false}>
            <PasswordResetScreen />
          </MobileBlocker>
        } />
        
        {/* Protected Dashboard Routes - Outside Layout */}
        <Route path="/dashboard" element={
          <MobileBlocker allowMobile={false}>
            <ProtectedRoute>
              <TurbineManagementScreen />
            </ProtectedRoute>
          </MobileBlocker>
        } />
        
        {/* Protected Turbine Detail Route - Outside Layout */}
        <Route path="/dashboard/turbine/:id" element={
          <MobileBlocker allowMobile={false}>
            <ProtectedRoute>
              <TurbineDetailScreen />
            </ProtectedRoute>
          </MobileBlocker>
        } />
        
        {/* Protected Turbine 360 View Route - Outside Layout */}
        <Route path="/dashboard/turbine/:id/360-view" element={
          <MobileBlocker allowMobile={false}>
            <ProtectedRoute>
              <Turbine360ViewScreen />
            </ProtectedRoute>
          </MobileBlocker>
        } />
        
        {/* Protected Operator Photos Route - Outside Layout */}
        <Route path="/turbine/:id/operator-photos" element={
          <MobileBlocker allowMobile={false}>
            <ProtectedRoute>
              <OperatorPhotosScreen />
            </ProtectedRoute>
          </MobileBlocker>
        } />
        
        {/* Protected Drone Photos Route - Outside Layout */}
        <Route path="/turbine/:id/drone-photos" element={
          <MobileBlocker allowMobile={false}>
            <ProtectedRoute>
              <DronePhotosScreen />
            </ProtectedRoute>
          </MobileBlocker>
        } />

        {/* Protected Robot Photos Route - Outside Layout */}
        <Route path="/turbine/:id/robot-photos" element={
          <MobileBlocker allowMobile={false}>
            <ProtectedRoute>
              <RobotPhotosScreen />
            </ProtectedRoute>
          </MobileBlocker>
        } />
        
        {/* Protected User Management Route - Outside Layout */}
        <Route path="/dashboard/users" element={
          <MobileBlocker allowMobile={false}>
            <ProtectedRoute>
              <UserManagementScreen />
            </ProtectedRoute>
          </MobileBlocker>
        } />
        
        {/* Protected Company Management Route - Outside Layout */}
        <Route path="/dashboard/companies" element={
          <MobileBlocker allowMobile={false}>
            <ProtectedRoute>
              <CompanyManagementScreen />
            </ProtectedRoute>
          </MobileBlocker>
        } />
        
        {/* Main Routes - With Layout */}
        <Route path="/" element={<Layout />}>
          <Route index element={<HomeScreen />} />
          <Route path="about" element={<AboutScreen />} />
          <Route path="contact" element={<ContactScreen />} />
          <Route path="robot" element={<RobotScreen />} />
          <Route path="privacy" element={<PrivacyScreen />} />
          <Route path="blog/:slug" element={<BlogDetailScreen />} />
        </Route>
        </Routes>
      </Router>
      </ErrorBoundary>
      </NotificationProvider>
    </LanguageProvider>
  )
}

export default App
